module.exports = __webpack_public_path__ + "fewww/img/title@2x.09f45d93.png";